import { render, staticRenderFns } from "./ConservativeTherapies.vue?vue&type=template&id=703be770&scoped=true"
import script from "./ConservativeTherapies.vue?vue&type=script&lang=js"
export * from "./ConservativeTherapies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703be770",
  null
  
)

export default component.exports